export enum SurveyStatus {
  OutsidePending = 0,
  Prefill = 8,
  OutsideOnGoing = 1,
  OutsideWaitingForValidation = 2,
  OutsideDone = 3,
  InsideOnGoing = 4,
  InsideDone = 5,
  InsidePending = 6,
  InsideWaitingForValidation = 7,
}
export const orderedSurveyStatus = [
  SurveyStatus.OutsidePending,
  SurveyStatus.Prefill,
  SurveyStatus.OutsideOnGoing,
  SurveyStatus.OutsideWaitingForValidation,
  SurveyStatus.OutsideDone,
  SurveyStatus.InsidePending,
  SurveyStatus.InsideOnGoing,
  SurveyStatus.InsideWaitingForValidation,
  SurveyStatus.InsideDone,
];
